import { type EntityEnum } from '@/common/types/general'
import { type FieldTypeEnum } from '@/common/types/fields'

export enum ColumnStatusEnum {
  LOADING = 'LOADING',
  ERROR = 'ERROR',
}

/**
 * Column definition for resultViewConfig
 */
export interface ColumnDefinition {
  code: string
  property: string
  sortable: boolean
  alwaysVisible: boolean
  label: string
  entity: EntityEnum
  type: FieldTypeEnum
  custom: boolean
  status?: ColumnStatusEnum
}

/**
 * Used to display entity table
 */
export interface ResultViewConfig {
  screenId: number
  sortBy: string | null // field code
  sortSens: 'asc' | 'desc' | null
  columns: ColumnDefinition[]
  page: number
  rowsPerPage: number
}
